import { z } from 'zod';
import { createPortalToolOutputSchema } from './portal-tool.schemas';
import { MCP_OAUTH_AUTHORIZE_TOOL_NAME } from './portal-tool.constants';

export { MCP_OAUTH_AUTHORIZE_TOOL_NAME };

export const McpOAuthAuthorizeInputSchema = z.object({
  identityId: z
    .string()
    .optional()
    .describe(
      'Optional MCP identity id to authorize. Uses default identity when omitted.',
    ),
  discoveryUrl: z
    .string()
    .url()
    .optional()
    .describe(
      'Optional MCP server URL used for OAuth discovery when creating the first OAuth identity.',
    ),
});

export const McpOAuthAuthorizeDataSchema = z.object({
  mcpServerId: z.string().optional(),
  identityId: z.string().optional(),
  openedSettings: z.boolean().optional(),
});

export const McpOAuthAuthorizeOutputSchema = createPortalToolOutputSchema({
  dataSchema: McpOAuthAuthorizeDataSchema,
});

export type McpOAuthAuthorizeInput = z.infer<
  typeof McpOAuthAuthorizeInputSchema
>;
export type McpOAuthAuthorizeOutput = z.infer<
  typeof McpOAuthAuthorizeOutputSchema
>;
